// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YzM6a","importantInfo":"styles_importantInfo__23mP3"};